/** Query-key root for asset-metadata server state (`GET /assets/:id/metadata`). */
export const ASSET_METADATA_KEY = 'asset-metadata' as const;
